let size_drawer = false;


$(".product_size_label").click(function(){
  size_drawer = true;
  $(this).parents('body').find('.size_drawer_wrapper').addClass('open_drawer');
  $(this).parents(".product__info-container").addClass('make_index'); 
  $(this).parents('body').find('.size_drawer_wrapper').addClass('open_overlay_drawer');
  $('body').addClass('overflow-hidden');
});






$(".drawer_overlay").click(function(){
  $(this).parents('body').find('.open_drawer').removeClass('open_drawer');
  $(this).parents(".product__info-container").removeClass('make_index');
  size_drawer = false;
  setTimeout(function() { 
    if(size_drawer == false){
      $('body').find('.size_drawer_wrapper').removeClass('open_overlay_drawer');
      $('body').removeClass('overflow-hidden');
    }
  }, 700);
});






$(".size-drawer_wrapper-close").click(function(){
  $(this).parents(".move_on_second").removeClass("move_on_second");
  $(this).parents(".size_drawer_wrapper-body").removeClass("move_full");
  $(this).parents('body').find('.open_drawer').removeClass('open_drawer');
  $(this).parents(".product__info-container").removeClass('make_index');
  size_drawer = false;
  setTimeout(function() { 
    if(size_drawer == false){
      $('body').find('.size_drawer_wrapper').removeClass('open_overlay_drawer');
      $('body').removeClass('overflow-hidden');
    }
  }, 700);
});




$(document).on("click","ul.size-drawer_wrapper-list label",function() {
  var input_value = $(this).attr('value'); 
  document.querySelector('.selected__size__body').innerHTML = input_value;
  $('body').find('.product_size_label').find('.selected__size__body').html(input_value);

  $(this).parents(".product__info-container").removeClass('make_index');

  $('body').find('.selected__size__body').addClass('show');
  $(this).parents('body').find('.size_drawer_wrapper').removeClass('open_drawer');
  size_drawer = false;
  setTimeout(function() { 
    if(size_drawer == false){
      $('body').find('.size_drawer_wrapper').removeClass('open_overlay_drawer');
      $('body').removeClass('overflow-hidden');
    }
  }, 500);
  $(this).parents("body").find(".product_info_right_bar").find(".product__buy_buttons").addClass("allow-add-product");
  $(this).parents("body").find(".product-popup-info-wrapper").find(".product__buy_buttons").addClass("allow-add-product");
  $(this).parents("body").find(".info_right_bar-size-btn").addClass("hide");
});



$(".size-drawer_wrapper-guide").click(function(){
  $(this).parents('.size_drawer_wrapper-body').addClass("move_on_second");
  $(this).parents('.size_drawer_wrapper-body').addClass("move_full");
  $(this).parents('.size_drawer_wrapper-body').removeClass("move_half");
});





$(".size_drawer_back").click(function(){
  $(this).parents('.size_drawer_wrapper-body').removeClass("move_on_second");
  $(this).parents('.service_drawer_wrapper-body').removeClass("open_item");
  $(this).parents('.size_drawer_wrapper-body').addClass("move_half");
  $(this).parents('.size_drawer_wrapper-body').removeClass("move_full");
  $(this).parents('.service_drawer_wrapper-body').removeClass("move_half");
  $(this).parents('body').find('.size-drawer_wrapper_second').removeClass('active');
});




$(".product_meta_wrapper_heading").click(function () {
  const $wrapper = $(this).closest(".product_meta_wrapper");
  const $text = $wrapper.find(".product_meta_wrapper_text");
  if ($wrapper.hasClass("open")) {
    $wrapper.removeClass("open");
    $text.stop(true, true).slideUp();
  } else {
    $(".product_meta_wrapper").removeClass("open");
    $(".product_meta_wrapper_text").stop(true, true).slideUp(); 
    $wrapper.addClass("open");
    $text.stop(true, true).slideDown();
  }
});

// $(".product__description_title").click(function () {
//   const $wrapper = $(this).closest(".product__description");
//   const $text = $wrapper.find(".product__description_text");
//   if ($wrapper.hasClass("open")) {
//     $wrapper.removeClass("open");
//     $text.stop(true, true).slideUp();
//   } else {
//     $(".product__description").removeClass("open");
//     $(".product__description_text").stop(true, true).slideUp(); 
//     $wrapper.addClass("open");
//     $text.stop(true, true).slideDown();
//   }
// });





$(".product_variations_item").click(function(){
  $(".product_variations_item").removeClass('active');
  $(this).addClass('active');
});




$(".services_wrapper").click(function(){
  size_drawer = true;
  $(this).parents('body').find('.service_drawer_wrapper').addClass('open_drawer');
  $(this).parents('body').find('.size_drawer_wrapper').addClass('open_overlay_drawer');
  $('body').addClass('overflow-hidden');
});



$(".size_drawer_btn").click(function(){
  $(this).parents('body').find(".product__info-container").addClass('make_index');
  $(this).parents('body').find('.size_drawer_wrapper').addClass('open_drawer');
  $(this).parents('body').find('.size_drawer_wrapper').addClass('open_overlay_drawer');
  $('body').addClass('overflow-hidden');
  size_drawer = true;
});

$(".select-size-popup-info").click(function(){
  size_drawer = true;
  $(this).parents('body').find('.size_drawer_wrapper').addClass('open_drawer');
  $(this).parents('body').find('.size_drawer_wrapper').addClass('open_overlay_drawer');
  $('body').addClass('overflow-hidden');
});




$("#complimentary_shipping").click(function(){
  $(this).parents('body').find('.service_drawer_1').addClass('active');
  $(this).parents('body').find('.service_drawer_wrapper-body').addClass('open_item');
  $('body').addClass('overflow-hidden');
});
$("#complimentary_retrn").click(function(){
  $(this).parents('body').find('.service_drawer_2').addClass('active');
  $(this).parents('body').find('.service_drawer_wrapper-body').addClass('open_item');
  $('body').addClass('overflow-hidden');
});
$("#complimentary_payments").click(function(){
  $(this).parents('body').find('.service_drawer_3').addClass('active');
  $(this).parents('body').find('.service_drawer_wrapper-body').addClass('open_item');
  $('body').addClass('overflow-hidden');
});
$("#complimentary_packaging").click(function(){
  $(this).parents('body').find('.service_drawer_4').addClass('active');
  $(this).parents('body').find('.service_drawer_wrapper-body').addClass('open_item');
  $('body').addClass('overflow-hidden');
});

$(document).ready(function () {
  $(".product_info_size_guide_wrapper").click(function () {
    if ($(window).width() <= 600) {
      $(this).parents("body").find(".product_size_label").click();
      $(this).parents("body").find(".size-drawer_wrapper-guide").click();
    }
  });
});




// $(document).on("click",".size-drawer_wrapper-list label",function() {
//   setTimeout(function() {
//     fetch(`${window.location.href}`).then((response) => {
//       return response.text();
//     })
//     .then((responseText) => {
//       if(document.querySelectorAll('.select-size-popup-info').length > 0){
//         const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.select-size-popup-info');
//         document.querySelector('.select-size-popup-info').innerHTML = html.innerHTML;
//       }

//       if(document.querySelectorAll('.product-form__group-size span').length > 0){
//         const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.product-form__group-size span');
//         document.querySelector('.product-form__group-size span').innerHTML = html.innerHTML;
//       }
//     })
//     .catch(e => {
//       console.error(e);
//     })
//     .finally(() => {
//     });
//   }, 50);
// });